import { Money as SharedMoney } from '@/components/ui/Money';

const stroke = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
} as const;

/** Empty-state and nav glyph for deals. */
export function DealIcon() {
  return (
    <svg {...stroke} className="h-5 w-5">
      <path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5Z" />
      <path d="M3 7.5 12 12l9-4.5" />
      <path d="M12 12v9" />
    </svg>
  );
}


/**
 * A money value, or an em dash when there is none.
 *
 * `null` means "no value recorded" everywhere in this API and is never the same
 * as `"0.00"`. Keeping the two visually distinct is the point — an unpriced deal
 * shown as 0 is a number someone will add up.
 */
export function Money({
  value,
  emptyLabel = 'Not set',
}: {
  value: string | null;
  emptyLabel?: string;
}) {
  if (value === null) {
    return (
      <span className="text-fg-subtle" title={emptyLabel}>
        —
      </span>
    );
  }
  return <SharedMoney amount={value} />;
}
